import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export const Testimonials = () => {
  const testimonials = [
    {
      logo: "https://everymatrix.com/wp-content/uploads/2023/12/Frame-56.svg",
      quote:
        "I would like to extend my huge thanks to Ebbe and EveryMatrix’s extraordinary teamwork...",
      name: "Marco Falchetto",
      position: "CEO",
    },
    {
      logo: "https://everymatrix.com/wp-content/uploads/2019/12/Group-3.svg",
      quote:
        "We have spent considerable time assessing potential B2B partners...",
      name: "Jack Dinan",
      position: "Commercial Product Manager Paddy Power Betfair",
    },
    {
      logo: "https://everymatrix.com/wp-content/uploads/2019/03/tipico-1.svg",
      quote:
        "We are impressed by EveryMatrix’s gaming portfolio and its ability to integrate...",
      name: "Marlon van der Goes",
      position: "Chief Commercial Officer",
    },
    {
      logo: "https://everymatrix.com/wp-content/uploads/2019/03/Frame-2.svg",
      quote:
        "EveryMatrix has done an excellent job by offering a rich and flexible solution...",
      name: "Hans Erland Ringsvold",
      position: "Head of VLT and iGaming",
    },
  ];
  return (
    <>
      <section className="testimonials sec-padd grayp">
        <div className="container container_custom">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-8 mx-auto text-center">
                  <h2 className="section-title">
                    Trusted by the Industry’s Best
                  </h2>
                  <p className="text-center">
                    We work with some of the biggest names in the iGaming
                    industry.
                  </p>

                  <Swiper
                    modules={[Pagination]}
                    // slidesPerView= {1.7}
                    spaceBetween={54}
                    pagination={{ clickable: true }}
                    loop={true}
                    centeredSlides={true}
                    roundLengths={true}
                    breakpoints={{
                      1199: { spaceBetween: 30, slidesPerView: 1.7 },
                      767: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                      },
                    }}
                    className="swiper-container"
                  >
                    {testimonials.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="inner">
                          <img src={item.logo} alt={`Logo of ${item.name}`} />
                          <blockquote>
                            <img
                              src="https://everymatrix.com/wp-content/themes/em/img/quotes-start.svg"
                              className="quotes-start"
                              alt="Quote Start"
                            />
                            {item.quote}
                            <img
                              src="https://everymatrix.com/wp-content/themes/em/img/quotes-end.svg"
                              className="quotes-end"
                              alt="Quote End"
                            />
                          </blockquote>
                          <hr />
                          <b className="name">{item.name}</b>
                          <span className="position">{item.position}</span>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
